export const titleText = "You've claimed your viking, Raider";
export const subtitleText = 'Wait for your next round to mint you second one';
export const ctaOneText = 'Back';
